@if (connection) {
  @if (isWorkDayConn) {
  <span class="ttFont ms-2">X</span>
  }
  @if (isAccessible) {
  <span class="ttFont ms-2">H</span>
  }
  @if (isReservable) {
  <span class="ttFont ms-2">R</span>
  }
  @if (isBaggage) {
  <span class="ttFont ms-2">L</span>
  }
  @if (isWifi) {
  <span class="ttFont ms-2">º</span>
  }
  @if (isPlug) {
  <span class="ttFont ms-2">³</span>
  }
  @if (connection.detour) {
  <app-detour></app-detour>
  }
}
